module.exports = __webpack_public_path__ + "fonts/iconfont.de71307a.eot";